module.exports = __webpack_public_path__ + "img/renke-4.5fd3c67e.png";